<p>registration-summary works!</p>
